import { render, staticRenderFns } from "./income-card.vue?vue&type=template&id=414b56bb&scoped=true"
import script from "./income-card.vue?vue&type=script&lang=js"
export * from "./income-card.vue?vue&type=script&lang=js"
import style0 from "./income-card.vue?vue&type=style&index=0&id=414b56bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414b56bb",
  null
  
)

export default component.exports